import { format, isToday, isValid, isYesterday } from 'date-fns';

/** Returns a Date from createdBy epoch ms, or null if missing/invalid. */
export function toCreatedByDate(createdBy: unknown): Date | null {
    if (typeof createdBy !== 'number' || !Number.isFinite(createdBy) || createdBy <= 0) {
        return null;
    }
    const date = new Date(createdBy);
    return isValid(date) ? date : null;
}

export function getDayKey(createdBy: unknown): string | null {
    const date = toCreatedByDate(createdBy);
    if (!date) {
        return null;
    }
    return format(date, 'yyyy-MM-dd');
}

/**  "Wednesday, 8 July, 2026 1:51 PM" */
export function getFullTimestampLabel(createdBy: unknown): string | null {
    const date = toCreatedByDate(createdBy);
    if (!date) {
        return null;
    }
    return format(date, 'EEEE, d MMMM, yyyy h:mm a');
}

/** Separator label: Today / Yesterday / "Wednesday, 8 July". */
export function getDaySeparatorLabel(createdBy: unknown): string | null {
    const date = toCreatedByDate(createdBy);
    if (!date) {
        return null;
    }
    if (isToday(date)) {
        return 'Today';
    }
    if (isYesterday(date)) {
        return 'Yesterday';
    }
    return format(date, 'EEEE, d MMMM');
}

export function conversationSpansMultipleDays(
    items: { createdBy?: number }[]
): boolean {
    const keys = new Set<string>();
    for (const item of items) {
        const key = getDayKey(item.createdBy);
        if (key) {
            keys.add(key);
            if (keys.size > 1) {
                return true;
            }
        }
    }
    return false;
}
